
import { Fragment } from "react";
import { Tooltip } from '@vds/tooltips';
import { getDisneyPromoDts, getNetxMaxPromoDts, getYoutubePremiumPromoDts } from "../DiscountFlowModal";
import { Body } from "@vds/typography";
import { connect } from "react-redux";

const StartNotification = (props) => {
   
    const { style = "white", label, tooltipTitle, tooltipMessage, showTooltip, dummyRibbon, netmaxOnly, showDetails, buildProduct} = props||{};
    const dataPlan = buildProduct?.internet?.selectedProduct?.name;
    let detailsModalTemplate;
    if (showDetails === "disney") {
        detailsModalTemplate = getDisneyPromoDts();
    } else if (showDetails === "netmax") {
        detailsModalTemplate = getNetxMaxPromoDts(dataPlan);
    } else if (showDetails === "youtube") {
        detailsModalTemplate = getYoutubePremiumPromoDts(dataPlan);
    } else {
        detailsModalTemplate = null;
    }
    return (<Fragment>
              { <div className={(netmaxOnly || showDetails === "youtube") ? '' : 'recommanded_title'} style={{ ...(dummyRibbon && { visibility: 'hidden' })}}>
                    {<span className={((netmaxOnly || showDetails === "youtube") && style?.color !== "black") ? "recommanded_redcaptitle_label" : "recommanded_title_label"}>{label}</span> }
                    { showTooltip && <Tooltip  title={tooltipTitle} size="small" surface="light"> {tooltipMessage} </Tooltip>}
                    {
                        // Explictily setting fontWeight to normal to reuse styles
                        /* Addomg checks for Disney and Netflix only for now as these two only are the promos.
                        Update below check if other promo comes in
                        */
                        (showDetails && detailsModalTemplate) && <span className={((netmaxOnly || showDetails === "youtube") && style?.color !== "black") ?"recommanded_redcaptitle_label" : "recommanded_title_label"} style={{ fontWeight: '400' }}>{detailsModalTemplate}</span>
                    }
                </div>
        }
        </Fragment>)

}

const mapStateToProps = state => {
    return {
        buildProduct: state.buildProduct
    }
}

export default connect(mapStateToProps)(StartNotification);